import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function OpuSemenTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  const getCellData = (key, index) => {
    if (!data || !data[index] || !data[index].summary) {
      return 'N/A';
    }

    if (key === 'husbandName') {
      return data[index].partnerName ?? 'N/A';
    }

    if (key === 'patientId') {
      return data[index].upid ?? 'N/A';
    }
    const summary = data[index].summary;

    if (key === 'retrieval') {
      const retrieval = summary.retrieval;
      let name = '';
      for (let i = 0; i < retrieval.length; i++) {
        if (retrieval[i].checked) {
          if (name === '') {
            name = retrieval[i].name;
          } else {
            name += ', ' + retrieval[i].name;
          }
        }
      }
      return name === '' ? 'N/A' : name;
    }

    if (key.includes('preWash') || key.includes('postWash')) {
      const [type, field] = key.split('.');
      if (summary[type][field] === '') return 'N/A';
      return summary[type][field] ?? 'N/A';
    }

    if (summary[key] === null || summary[key] === '') {
      return 'N/A';
    }
    return summary[key] ?? 'N/A';
  };
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={16}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            SEMEN SAMPLE DETAIL
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>Husband Name</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Patient ID</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Source of Sperm</TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            <div style={{ width: '80px' }}>Retrieval</div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Abstinance (in Days)
          </TableCell>
          <TableCell colSpan={5} style={{ fontWeight: 700 }}>
            <div style={{ width: '100%', textAlign: 'center' }}>PRE WASH</div>
          </TableCell>
          <TableCell colSpan={5} style={{ fontWeight: 700 }}>
            <div style={{ width: '100%', textAlign: 'center' }}>POST WASH</div>
          </TableCell>
          <TableCell style={{ fontWeight: 700, ...borderRight }}>
            Comments
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={5}>
            <div style={{ height: '20px' }}></div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>Volume</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Concentration</TableCell>
          <TableCell style={{ fontWeight: 700 }}>TM</TableCell>
          <TableCell style={{ fontWeight: 700 }}>PR</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Morphology</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Volume</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Concentration</TableCell>
          <TableCell style={{ fontWeight: 700 }}>TM</TableCell>
          <TableCell style={{ fontWeight: 700 }}>PR</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Morphology</TableCell>
          <TableCell style={{ fontWeight: 700, ...borderRight }}></TableCell>
        </TableRow>
        {data &&
          data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('husbandName', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('patientId', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('sperm', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('retrieval', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('abstinance', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('preWash.volume', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('preWash.concentration', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('preWash.totalMotility', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('preWash.progressiveMotility', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('preWash.morphology', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('postWash.volume', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('postWash.concentration', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('postWash.totalMotility', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('postWash.progressiveMotility', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('postWash.morphology', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('spermPreparationComment', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default OpuSemenTable;
